import axios from "axios";
import { toast } from "react-toastify";

function trimDeep(value) {
  // Preserve FormData / binary payloads
  if (value instanceof FormData) return value;

  if (typeof value === "string") {
    return value.replace(/\s+/g, " ").trim();
  }

  // Preserve Date objects (critical for quoteDate casting in backend/Mongoose)
  if (value instanceof Date) return value;

  if (Array.isArray(value)) {
    return value.map((v) => trimDeep(v));
  }

  // Only deep-trim plain objects. For anything else (e.g. class instances),
  // return as-is to avoid turning them into {}.
  if (value && typeof value === "object") {
    const proto = Object.getPrototypeOf(value);
    const isPlainObject = proto === Object.prototype || proto === null;
    if (!isPlainObject) return value;

    const out = { ...value };
    Object.entries(out).forEach(([k, v]) => {
      out[k] = trimDeep(v);
    });
    return out;
  }

  return value;
}

// function getToken() {
//   if (localStorage.getItem("user")) {
//     const parseData = JSON.parse(localStorage.getItem("user") || "");
//     return parseData.accessToken;
//   }
//   return "";
// }

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/api`,

  // baseURL: `http://localhost:4002/api`,
  //   headers: {
  //     "Content-Type": "application/json",
  //     "cache-control": "no-cache",
  //   },
});

function getToken() {
  if (localStorage.getItem("token")) {
    const token = JSON.parse(localStorage.getItem("token") || "");
    return token;
  }
  return "";
}
instance.interceptors.request.use(
  async (config) => {
    config.headers.Authorization = `Bearer ${getToken()}`;

    // Ensure all admin/user form inputs are trimmed before reaching backend.
    // This prevents leading/trailing and excessive internal whitespace from
    // being persisted to the DB.
    if (config?.data && typeof config.data === "object") {
      config.data = trimDeep(config.data);
    }
    if (config?.params && typeof config.params === "object") {
      config.params = trimDeep(config.params);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    const suppressToast = response?.config?.suppressToast === true;
    if (!suppressToast && response.data?.message) {
      toast.success(response.data?.message);
    }
    return response;
  },
  (error) => {
    const suppressToast = error?.config?.suppressToast === true;
    if (error.response?.status === 401) {
      localStorage.removeItem("cart");
      localStorage.removeItem("persist:auth");
      localStorage.removeItem("token");
      window.location.href = "/auth";
    }

    console.log(error);

    if (!suppressToast) {
      if (error.response?.data?.message) {
        toast.error(error.response.data?.message);
      } else if (error.response?.data?.error) {
        toast.error(error.response.data.error);
      } else if (error?.message) {
        toast.error(error?.message);
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
